import React, { useState, useEffect } from "react";
import fitnessImage from "../assets/fitness.png";
import "../styles/Training.css";
import mockTestImage from "../assets/mock.png";



const Home = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollButton(true);
      } else {  
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="home-page">



      <div className="container text-animation-container">
        <div className="animated-texttr">
          <div className=".container.visible ">
          </div>
          SSB Academy equips individuals with expert training to achieve excellence in defense and competitive exams.

        </div>
      </div>

 
      <div className="bg-image-containertrain">
        {/* <div className="centered-text">
          Prepare for Excellence
        </div> */}
      </div>
      <section className="hero-section">
        <h1>SSB Academy Training Programs</h1>
        <p>Comprehensive Training for Future Defense Leaders</p>
      </section>

      <section className="overview-section">
        <h2>Why Choose Our SSB Training?</h2>
        <p>
          Our <strong>SSB Training Program</strong> is meticulously designed to prepare candidates for the 
          rigorous <strong>Services Selection Board (SSB) interview process</strong>. With a structured 
          approach and experienced trainers, we ensure that every candidate is equipped 
          with the necessary skills to succeed.
        </p>
      </section>
      <section className="training-modules">
        <h2>Our Training Modules</h2>
        <ul>
          <li>
            <strong>Psychological Training:</strong> Practice Thematic Apperception Test (TAT), Word Association Test (WAT), Situation Reaction Test (SRT), Self-Description Test (SDT).
          </li>
          <li>
            <strong>Group Tasks:</strong> Participate in Group Discussion (GD), Group Planning Exercise (GPE), Progressive Group Task (PGT), Half Group Task (HGT), Command Task, Individual Obstacles.
          </li>
          <li>
            <strong>Personal Interview Guidance:</strong> One-on-one mock interviews with experienced ex-defense officers.
          </li>
          <li>
            <strong>Communication Skills Development:</strong> Improve spoken English, body language, and confidence.
          </li>
          <li>
            <strong>Physical Fitness Training:</strong> Enhance stamina, endurance, and agility with defense-oriented exercises.
          </li>
          <li>
            <strong>Mock SSB Tests:</strong> Experience real-time SSB interview simulations and feedback sessions.
          </li>
        </ul>
      </section>

      <section className="selection-process">
        <h2>Understanding the SSB Selection Process</h2>
        <p>The <strong>SSB Interview</strong> consists of multiple stages that assess a candidate’s mental, physical, and leadership qualities.</p>
        <ul>
          <li><strong>Stage 1: Screening Test</strong> - Includes Officer Intelligence Rating (OIR) Test & Picture Perception and Discussion Test (PPDT).</li>
          <li><strong>Stage 2: Psychological Testing</strong> - Assesses personality traits through written tests.</li>
          <li><strong>Stage 3: Group Testing</strong> - Involves various physical and mental group tasks.</li>
          <li><strong>Stage 4: Personal Interview</strong> - Conducted by senior defense officers.</li>
          <li><strong>Stage 5: Conference Round</strong> - The final decision-making stage.</li>
        </ul>
      </section>

      <section className="fitness-section">
        <img src={fitnessImage} alt="Physical fitness training" className="fitness-image" />
        <h2>Physical Fitness Training</h2>
        <p>
          Physical fitness plays a crucial role in clearing the <strong>SSB Interview</strong>. 
          Our fitness programs focus on running drills, strength training, endurance 
          exercises, and obstacle courses to prepare candidates for the <strong>Individual Obstacles task</strong>.
        </p>
      </section>

      <section className="mock-tests-section">
        <img src={mockTestImage} alt="Mock tests for SSB preparation" className="mock-test-image" />
        <h2>Mock SSB Tests & Interview Preparation</h2>
        <p>
          To ensure complete readiness, we conduct <strong>weekly mock SSB tests</strong>, 
          including psychological tests, group discussions, personal interviews, and 
          real-time feedback sessions. These tests <strong>simulate real-life scenarios</strong> and 
          boost confidence.
        </p>
      </section>

      <section className="faqs-section">
        <h2>Frequently Asked Questions (FAQs)</h2>
        
        <details className="faq">
          <summary>Who can apply for the SSB Training Program?</summary>
          <p>Any candidate aspiring to join the <strong>Indian Army, Navy, or Air Force</strong> through NDA, CDS, AFCAT, or other defense exams can enroll in our training.</p>
        </details>
        
        <details className="faq">
          <summary>What is the duration of the training program?</summary>
          <p>Our programs range from <strong>7-day intensive training</strong> to <strong>1-month comprehensive coaching</strong>, depending on the candidate's needs.</p>
        </details>

        <details className="faq">
          <summary>What is the success rate of your academy?</summary>
          <p>We take pride in our <strong>high success rate</strong>, with numerous candidates successfully clearing their SSB interviews and joining the armed forces.</p>
        </details>
      </section>

      <section className="contact-section">
        <h2>Enroll Today!</h2>
        <p>
          Ready to begin your journey towards <strong>SSB success</strong>? Contact us at 
          <strong> contact@ssbacademy.com</strong> or visit our center for enrollment details.
        </p>
      </section>

   




     



      {showScrollButton && (
        <div className="scroll-to-top">
          <button onClick={scrollToTop}>
            ↑
          </button>
        </div>
      )}
    </div>
  );
};

export default Home;